import { useEffect, useState } from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * Colores de grafica leidos del sistema de diseno.
 *
 * Recharts recibe colores como props, no como CSS, asi que no puede consumir
 * las variables directamente. En lugar de duplicar la paleta en JavaScript
 * -que es como el proyecto acabo con azules distintos en la hoja y en el
 * grafico- se leen las mismas variables del documento y se recalculan cuando
 * cambia el tema. Una sola fuente de verdad para ambos.
 */

const TOKENS = {
  water: '--data-water',
  waterFill: '--data-water-fill',
  goal: '--data-goal',
  over: '--data-over',
  compare: '--data-compare',
  grid: '--data-grid',
  axis: '--data-axis',
  primary: '--primary',
  success: '--success',
  warning: '--warning',
  danger: '--danger',
  info: '--info',
  text: '--text-secondary',
  surface: '--bg-surface',
  border: '--border',
};

const FALLBACK = {
  water: '#1c6b7a',
  waterFill: 'rgba(28, 107, 122, 0.14)',
  goal: '#a86a12',
  over: '#b3352f',
  compare: '#78827e',
  grid: '#e6eae9',
  axis: '#78827e',
  primary: '#2c6a51',
  success: '#2c6a51',
  warning: '#a86a12',
  danger: '#b3352f',
  info: '#1c6b7a',
  text: '#55605c',
  surface: '#ffffff',
  border: '#e2e7e5',
};

function read() {
  if (typeof window === 'undefined') return FALLBACK;
  const styles = getComputedStyle(document.documentElement);
  const out = {};
  Object.entries(TOKENS).forEach(([key, variable]) => {
    const value = styles.getPropertyValue(variable).trim();
    out[key] = value || FALLBACK[key];
  });
  return out;
}

export function useChartTokens() {
  const { theme } = useTheme();
  const [tokens, setTokens] = useState(read);

  useEffect(() => {
    // Un frame de margen: con View Transitions el atributo cambia dentro de la
    // transicion y leer en el mismo tick devolveria todavia la paleta anterior.
    const id = requestAnimationFrame(() => setTokens(read()));
    return () => cancelAnimationFrame(id);
  }, [theme]);

  return tokens;
}

export default useChartTokens;
